import { CountryPrice } from './price';

interface Bundle {
    id?: number;
    name: string;
    url: string;
    gp_url: string;
    price: number;
    price_19: number;
    price_by_country?: CountryPrice[];
    updated_at?: string;
    updated_by: string;
}

export enum KindApp {
    'Huawei AdExchange' = 'main',
    'Xiaomi' = 'xiaomi',
    'Xiaomi Mixed' = 'xiaomimixed',
    'Vivo' = 'vivo',
    'Vivo Mixed' = 'vivomixed',
    'Oppo Mixed' = 'oppomixed',
    'Motorola Mixed' = 'motorolamixed',
    'Transsion Bidding' = 'transsionbidding',
}

export interface BundleWeight {
    id?: number;
    bundle: string;
    country: string;
    weights: Record<string, number>;
    created_at?: string;
    updated_at?: string;
    updated_by: string;
}

export default Bundle;
